import { render, staticRenderFns } from "./PartPopupCommTable.vue?vue&type=template&id=80a17346&"
import script from "./PartPopupCommTable.vue?vue&type=script&lang=js&"
export * from "./PartPopupCommTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports